import styled from 'styled-components'

export const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    margin: 0px 0px 0px 17px;
    height: 60px;
`

export const MainText = styled.p<{ goodSamStyling?: boolean }>`
    color: ${(props) =>
        props.goodSamStyling
            ? props.theme.colors.monochrome.white
            : props.theme.colors.brand.rideOctaneBlue};
    font-family: Karla;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    margin: 0 0 3px 0;
    max-width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const PhoneNumber = styled.p<{ goodSamStyling?: boolean }>`
    color: ${(props) =>
        props.goodSamStyling
            ? props.theme.colors.monochrome.white
            : props.theme.colors.monochrome.ravenSub};
    font-family: Karla;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    margin: 0;
    max-width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`
